import React, { useState } from "react";
import DownloadComplementary from "../DowloadComplementary/DownloadComplementary";
import { QuizInlineCard } from "../QuizInlineCard";
import {
  Typography,
  Icon,
  Button,
  Avatar,
  Box,
  Tooltip,
  Divider,
} from "@material-ui/core";
import { Translator } from "@itarget/shared";
import { enumsSchedule, ShowVideoLecture } from "@itarget/shared/src/enums";
import { useStyles } from "./styles";

const StepperDetailCourse = ({
  steps = [],
  selectStep,
  openQuestionFromCurrentLessonWithQuestionId,
  finalResults = [],
  isLoadingFinalResult = false,
  settingCommerce,
  isLoadingDetail,
  subModule = false,
  handleModalIframe,
}) => {
  const totalAssisted = steps[0]?.total_assistido
    ? parseFloat(steps[0]?.total_assistido)
    : false;
  const percentageDisplayQuizFA = settingCommerce?.meta_videosaulas
    ? parseFloat(settingCommerce?.meta_videosaulas)
    : false;
  const alreadyWatched = steps[0]?.total_assistido >= 99;
  const watchedSomething = steps[0]?.total_assistido > 0;

  const classes = useStyles({
    finishedLesson: steps[0]?.total_assistido > 99,
    hasLinkVideo: !!steps[0]?.link_video_palestrante,
    alreadyWatched: alreadyWatched,
    watchedSomething: watchedSomething,
  });

  if (!steps.length || !steps[0] || !Array.isArray(finalResults)) {
    return null;
  }

  const translation = {
    watchAgain: Translator({ transRef: "translation.Rever" }),
    watch: Translator({ transRef: "translation.Assistir" }),
    unavailable: Translator({ transRef: "translation.Indisponível" }),
    dynamicLesson: Translator({ transRef: "translation.acessar aula" }),
    yes: Translator({ transRef: "translation.Sim" }).props.children,
    no: Translator({ transRef: "translation.Não" }).props.children,
    attemptsProceed: Translator({
      transRef:
        "translation.Atenção: Você possui (%s) tentativas restantes. Deseja prosseguir?",
    }).props.children,
    attemptProceed: Translator({
      transRef:
        "translation.Atenção: Você possui (%s) tentativa restante. Deseja prosseguir?",
    }).props.children,
    notAnswered: Translator({ transRef: "translation.Não respondido" }).props
      .children,
    questionnary: Translator({ transRef: "translation.Questionário" }).props
      .children,
    questionnaires: Translator({ transRef: "translation.Questionários" }).props
      .children,
    notDefined: Translator({ transRef: "translation.Não definido" }).props
      .children,
    showAnswers: Translator({ transRef: "translation.Resultados" }).props
      .children,
    files: Translator({ transRef: "translation.Arquivos" }).props.children,
  };

  const stepIcon = (course) => (
    <div className={classes.root}>
      <Avatar className={classes.icon}>
        <Icon className={classes.iconStep}>
          {course.total_assistido > 99 ? "verified" : "ondemand_video"}
        </Icon>
      </Avatar>
    </div>
  );

  const ConditionalButton = ({ course, speakers, quizFA, quizzesFV = [] }) => {
    const [openStatus, setOpenStatus] = useState(false);
    const changeStatus = () => setOpenStatus((prev) => !prev);
    const alreadyWatched = course.total_assistido >= 99;
    const hasResultsInsideQuizzesFV = quizzesFV.some(
      (quiz) =>
        Number(quiz.tipo_questionario) !== 2 &&
        quiz.ead_exibir_respostas === "S"
    );

    const showWatchButton = () => {
      const scheduleValidityMode = steps[0]["modo_vigencia"];
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (
        scheduleValidityMode ===
          enumsSchedule.SCHEDULE_VALIDITY_MODE.NOT_APPLICABLE ||
        scheduleValidityMode === undefined
      )
        return true;

      if (
        scheduleValidityMode ===
          enumsSchedule.SCHEDULE_VALIDITY_MODE.FIXED_DATE &&
        new Date(`${steps[0]["data_vigencia_fixa"]}T00:00:00`) >= today
      )
        return true;

      if (
        scheduleValidityMode ===
          enumsSchedule.SCHEDULE_VALIDITY_MODE.ACCORDING_TO_THE_INSCRIPTION &&
        new Date(`${steps[0]["data_vigencia_associacao"]}T00:00:00`) >= today
      )
        return true;

      return false;
    };

    if (!course.link_video_palestrante && !course.link_video_aula_dinamica)
      return null;

    return (
      <div className={classes.listOndemandConditionButtonContainer}>
        {course?.arquivo?.length > 0 && (
          <>
            <DownloadComplementary
              handleClose={changeStatus}
              openStatus={openStatus}
              files={course.arquivo}
            />
            <Button
              startIcon={<Icon>folder</Icon>}
              variant="text"
              onClick={changeStatus}
            >
              <Typography className={classes.buttonLabel}>
                {translation.files}
              </Typography>
            </Button>
          </>
        )}

        {!isLoadingFinalResult && !quizFA && course.exibir_questionario && (
          <Tooltip
            title={
              percentageDisplayQuizFA && percentageDisplayQuizFA > totalAssisted
                ? `A avaliação será exibida após ${percentageDisplayQuizFA}% do vídeo.`
                : ""
            }
          >
            <Button
              startIcon={<Icon>analytics</Icon>}
              variant="text"
              disabled={
                percentageDisplayQuizFA &&
                percentageDisplayQuizFA > totalAssisted
              }
              onClick={handleClickOpenQuiz}
            >
              <Typography className={classes.buttonLabel}>
                {translation.questionnary}
              </Typography>
            </Button>
          </Tooltip>
        )}

        {!isLoadingFinalResult &&
          ((quizFA?.ead_exibir_respostas &&
            quizFA?.ead_exibir_respostas === "S") ||
            hasResultsInsideQuizzesFV) && (
            <Button
              startIcon={<Icon>assignment</Icon>}
              variant="text"
              onClick={() => selectStep(course, speakers, "answers")}
            >
              <Typography className={classes.buttonLabel}>
                {translation.showAnswers}
              </Typography>
            </Button>
          )}

        {showWatchButton() ? (
          <div className="btn-container">
            {[ShowVideoLecture.BOTH, ShowVideoLecture.SCHEDULE].includes(course.exibe_video_palestra) && course.link_video_palestrante && (
              <Button
                startIcon={
                  alreadyWatched ? (
                    <Icon>replay</Icon>
                  ) : (
                    <Icon>ondemand_video</Icon>
                  )
                }
                variant="text"
                disabled={isLoadingDetail}
                className={classes.watchButton}
                onClick={() => selectStep(course, speakers, "video")}
              >
                <Typography className={classes.buttonLabel}>
                  {alreadyWatched ? translation.watchAgain : translation.watch}
                </Typography>
              </Button>
            )}

            {course.link_video_aula_dinamica && (
              <Button
                className={classes.watchButton}
                onClick={() => handleModalIframe(course, true)}
                startIcon={<Icon>ondemand_video</Icon>}
                variant="text"
                disabled={isLoadingDetail}
              >
                <Typography className={classes.buttonLabel}>
                  {translation?.dynamicLesson}
                </Typography>
              </Button>
            )}
          </div>
        ) : (
          <Button className={`btn-watch ${classes.unavailableButton}`}>
            <Icon className={classes.buttonIcon}>block</Icon>
            <Typography className={classes.buttonLabel}>
              {translation.unavailable}
            </Typography>
          </Button>
        )}
      </div>
    );
  };

  const getSpeakers = (speaker) => {
    if (speaker.formattedSpeaker) {
      return speaker.formattedSpeaker;
    }
    const name = speaker.palestrantes_nome || speaker.nome_palestrante;
    if (!name) return "";
    const location =
      speaker.municipio_palestrante && speaker.uf_palestrante
        ? ` (${speaker.municipio_palestrante} - ${speaker.uf_palestrante})`
        : "";
    return `${name}${location}`;
  };

  const detailId = steps[0]?.agenda_atividade_detalhe_id;

  const quizzes = finalResults.filter(
    (quiz) => quiz.agenda_atividade_detalhe_id === detailId
  );
  const quizzesFA = quizzes.filter((quiz) => quiz.tipo === "FA");
  const quizzesFV = quizzes.filter((quiz) => quiz.tipo === "FV");
  const visibleQuizzesFV = quizzesFV.filter(
    (quiz) => Number(quiz.tipo_questionario) !== 2
  );

  const handleClickOpenQuiz = async () => {
    await openQuestionFromCurrentLessonWithQuestionId(steps[0]);
  };

  if (subModule && quizzes.length === 0) return <></>;

  const date = steps[0].data_atividade
    ? new Date(`${steps[0].data_atividade}T00:00:00`)
    : null;
  const day = date?.getDate();
  const month = date?.toLocaleDateString("pt-BR", {
    month: "short",
  });
  const dateInit = steps[0]?.hora_inicio
    ? steps[0]?.hora_inicio.split(":")
    : "";
  const formattedInitHour = dateInit ? `${dateInit[0]}h${dateInit[1]}` : "";

  const dateEnd = steps[0]?.hora_fim ? steps[0]?.hora_fim.split(":") : "";
  const formattedEndHour = dateEnd ? `${dateEnd[0]}h${dateEnd[1]}` : "";

  return (
    <div className={classes.listOnDemandContainer}>
      {steps[0]?.tipo_registro == "P" && (
        <>
          {day && month && (
            <Box alignItems="center" className={classes.timeContainer}>
              <Typography className={classes.day}>{day}</Typography>
              <Typography className={classes.month}>{month}</Typography>
            </Box>
          )}

          {formattedInitHour && formattedEndHour && (
            <div className={classes.timeContainer}>
              <Typography className={classes.initTime}>
                {formattedInitHour}
              </Typography>
              <Typography className={classes.endTime}>
                {formattedEndHour}
              </Typography>
            </div>
          )}
        </>
      )}

      <div
        data-has-time={
          steps[0]?.tipo_registro == "P" &&
          (!!(formattedInitHour && formattedEndHour) || !!(day && month))
        }
        className={classes.listOndemand}
      >
        <div className={classes.container}>
          {!subModule && (
            <div className={classes.info}>
              <div className={classes.infoRow}>
                {selectStep && stepIcon(steps[0])}
                <Typography
                  variant="subtitle1"
                  className={classes.lessonTitle}
                  onClick={
                    [ShowVideoLecture.BOTH, ShowVideoLecture.SCHEDULE].includes(steps[0].exibe_video_palestra) && steps[0].link_video_palestrante
                      ? () =>
                          selectStep(steps[0], getSpeakers(steps[0]), "video")
                      : undefined
                  }
                >
                  {steps[0].titulo_palestra}
                </Typography>
              </div>

              <div className={classes.speakerInfo}>
                {getSpeakers(steps[0]) && getSpeakers(steps[0]) !== "." && (
                  <div>
                    <Icon>person</Icon>
                    <Typography variant="body2">
                      {getSpeakers(steps[0])}
                    </Typography>
                  </div>
                )}

                {steps[0].tempo_video_palestrante && (
                  <div>
                    <Icon>access_time</Icon>
                    <Typography variant="body2">
                      <Translator transRef="translation.Duração" />:{" "}
                      {steps[0].tempo_video_palestrante}
                    </Typography>
                  </div>
                )}
              </div>
            </div>
          )}

          {selectStep && steps[0]?.tipo_registro == "P" && (
            <div className={classes.buttons}>
              <ConditionalButton
                quizFA={quizzesFA[0]}
                quizzesFV={visibleQuizzesFV}
                course={steps[0]}
                speakers={getSpeakers(steps[0])}
              />
            </div>
          )}
        </div>
        <Box>
          {(quizzesFA && quizzesFA.length > 0) && (steps && steps[0] && steps[0]?.suspender_questionario !== "S") && (
            <QuizInlineCard className={classes.finalQuizInlineCard}>
              <QuizInlineCard.Header
                title="Avaliação final"
                tooltip={
                  percentageDisplayQuizFA
                    ? `Esta aula possui avaliação final após execução do vídeo. A avaliação será exibida após ${percentageDisplayQuizFA}% do vídeo.`
                    : "Esta aula possui avaliação final após execução do vídeo."
                }
              />
              {quizzesFA.map((quiz, index) => {
                if (
                  !quiz.respostas_tentativas_f ||
                  quiz.respostas_tentativas_f === 0
                ) {
                  return (
                    <Button
                      disabled={
                        percentageDisplayQuizFA &&
                        percentageDisplayQuizFA > totalAssisted
                      }
                      startIcon={<Icon>analytics</Icon>}
                      variant="text"
                      onClick={handleClickOpenQuiz}
                    >
                      <Typography className={classes.buttonLabel}>
                        {translation.questionnary}
                      </Typography>
                    </Button>
                  );
                }

                const showResultsButton =
                  subModule &&
                  quiz.ead_exibir_respostas === "S" &&
                  quiz.respostas_tentativas_f > 0;
                const attemptsUsed = parseInt(quiz.respostas_tentativas_f) || 0;
                const attemptLimit = parseInt(
                  settingCommerce?.meta_num_tentativas
                );
                const unlimitedAttempts = !attemptLimit || attemptLimit === 0;
                const canAttempt =
                  unlimitedAttempts || attemptsUsed < attemptLimit;

                return (
                  <div
                    key={index}
                    className={classes.quizItemWithResultsButton}
                  >
                    {showResultsButton && (
                      <Button
                        startIcon={<Icon>assignment</Icon>}
                        variant="text"
                        size="small"
                        onClick={() =>
                          selectStep(steps[0], getSpeakers(steps[0]), "answers")
                        }
                        className={classes.showAnswersButton}
                      >
                        <Typography className={classes.buttonLabel}>
                          Resultados
                        </Typography>
                      </Button>
                    )}
                    {canAttempt && (
                      <Button
                        startIcon={<Icon>analytics</Icon>}
                        variant="text"
                        size="small"
                        onClick={handleClickOpenQuiz}
                        className={classes.retakeButton}
                      >
                        <Typography className={classes.buttonLabel}>
                          {translation.questionnary}
                        </Typography>
                      </Button>
                    )}
                    <QuizInlineCard.Item
                      label={`${quiz.descricao_formulario}${
                        quiz.ead_exibir_desempenho &&
                        quiz.ead_exibir_desempenho === "S"
                          ? parseFloat(quiz.respostas_pontuacao_f) > -1
                            ? ` - ${parseFloat(quiz.respostas_pontuacao_f)}%`
                            : " - Não respondido"
                          : ""
                      }`}
                      status={
                        parseFloat(quiz.respostas_pontuacao_f) > -1
                          ? "respondido"
                          : "pendente"
                      }
                    />
                  </div>
                );
              })}
            </QuizInlineCard>
          )}

          {(visibleQuizzesFV && visibleQuizzesFV.length > 0) && (steps && steps[0] && steps[0]?.suspender_questionario !== "S") && (
            <QuizInlineCard className={classes.videoQuizInlineCard}>
              <QuizInlineCard.Header
                title="Questionários/enquetes do vídeo"
                tooltip="Esta aula possui questionários a serem respondidos durante a execução do vídeo"
              />
              {visibleQuizzesFV.map((quiz, index) => {
                return (
                  <QuizInlineCard.Item
                    key={index}
                    label={`${quiz.descricao_formulario}${
                      quiz.ead_exibir_desempenho &&
                      quiz.ead_exibir_desempenho === "S"
                        ? parseFloat(quiz.respostas_pontuacao_f) > -1
                          ? ` - ${parseFloat(quiz.respostas_pontuacao_f)}%`
                          : " - Não respondido"
                        : ""
                    }`}
                    status={
                      parseFloat(quiz.respostas_pontuacao_f) > -1
                        ? "respondido"
                        : "pendente"
                    }
                  />
                );
              })}
            </QuizInlineCard>
          )}
        </Box>
      </div>
    </div>
  );
};

export default StepperDetailCourse;
